import { NavLink } from "react-router-dom";
import logo from "../assets/logo.png";

const PERMISSIONS = {
  DASHBOARD: "order.view_dashboard",
  ORDER: "order.view_order",
  PURCHASE: "order.view_purchase",
  INVENTORY: "inventory.view_sheet",
  BILLING: "order.view_billing_page",
};

function Sidebar({ collapsed, mobileOpen, setMobileOpen, user }) {

  const hasPermission = (perm) => {
    return user?.permissions?.includes(perm);
  };

  return (
    <>
      {mobileOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <div
        className={`sidebar d-flex flex-column ${
          mobileOpen ? "sidebar-open" : ""
        }`}
        style={{
          width: collapsed ? "80px" : "250px",
        }}
      >
        <div className="text-center mb-5">
          <img
            src={logo}
            alt="Logo"
            style={{
              width: collapsed ? "50px" : "180px",
              transition: "0.3s",
            }}
          />
        </div>

        <ul className="nav flex-column gap-2">

          {/* Dashboard */}
          {hasPermission(PERMISSIONS.DASHBOARD) && (
            <SidebarItem to="/dashboard" label="Dashboard" collapsed={collapsed} />
          )}

          {/* Orders */}
          {hasPermission(PERMISSIONS.ORDER) && (
            <SidebarItem to="/order" label="Orders" collapsed={collapsed} />
          )}

          {/* Purchases */}
          {hasPermission(PERMISSIONS.PURCHASE) && (
            <SidebarItem to="/purchase" label="Purchases" collapsed={collapsed} />
          )}

          {/* Inventory */}
          {hasPermission(PERMISSIONS.INVENTORY) && (
            <SidebarItem to="/inventory" label="Inventory" collapsed={collapsed} />
          )}

          {/* Billing */}
          {hasPermission(PERMISSIONS.BILLING) && (
            <SidebarItem to="/billing" label="Billing" collapsed={collapsed} />
          )}

        </ul>

        <div className="mt-auto text-center small pt-4">
          {!collapsed && "© 2026 Star Laser India"}
        </div>
      </div>
    </>
  );
}

function SidebarItem({ to, label, collapsed }) {
  return (
    <li className="nav-item">
      <NavLink
        to={to}
        end={to === "/"}
        className={({ isActive }) =>
          `sidebar-link ${isActive ? "active-sidebar" : ""}`
        }
      >
        {collapsed ? label.charAt(0) : label}
      </NavLink>
    </li>
  );
}

export default Sidebar;